import { useBusinessNav } from '@/hooks/useBusinessNav';
import { useApp } from '@/components/AppLayout';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Plus,
  Receipt,
  ClipboardPenLine,
  BanknoteArrowUp,
  ClipboardList,
  Users,
  Package,
} from 'lucide-react';

export function QuickCreateMenu() {
  const { nav } = useBusinessNav();
  const { isViewOnly } = useApp();

  if (isViewOnly) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="gap-1.5 rounded-full">
          <Plus className="size-4" />
          <span className="hidden sm:inline">Create New</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={() => nav('/invoices/create')} className="cursor-pointer">
          <Receipt className="size-4 mr-2" />
          Invoice
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => nav('/quotes/create')} className="cursor-pointer">
          <ClipboardPenLine className="size-4 mr-2" />
          Quote
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => nav('/credit-memos/create')} className="cursor-pointer">
          <BanknoteArrowUp className="size-4 mr-2" />
          Credit Memo
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => nav('/purchase-orders/create')} className="cursor-pointer">
          <ClipboardList className="size-4 mr-2" />
          Purchase Order
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => nav('/clients?new=true')} className="cursor-pointer">
          <Users className="size-4 mr-2" />
          Client
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => nav('/items?new=true')} className="cursor-pointer">
          <Package className="size-4 mr-2" />
          Item
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
